import { CheckCircleFilled, HistoryOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useEffect, useState } from "react";
import moment from "moment";
import "./CustomModal.css";


const NewBid = ["New", "Accepted", "Declined", "Retracted"];
const InReview = [
  "Profile Submitted",
  "Interview",
  "Interview Accepted",
  "Interview Cancelled",
  "Offer",
  "Offer Accepted",
  "Offer Declined",
];
const Hired = ["Hired", "On Billing", "Billing Extend"];
const Final = ["Off Billing", "Canceled", "Terminated"];

export default function CustomModal(props) {
  const [status, setStatus] = useState("");
  const [seeHistory, setSeeHistory] = useState();
  useEffect(() => {
    setStatus(props.status);
    setSeeHistory(props.history);
  }, [props.status,props.history]);

  const [newBidTiming, setNewBidTiming] = useState("2 weeks ago");
  const [bidAcceptedTiming, setBidAcceptedTiming] = useState("2 weeks ago");
  const [profileSubmittedTiming, setProfileSubmittedTiming] =
    useState("1 week ago");
  const [interviewTiming, setInterviewTiming] = useState("1 week ago");
  const [interviewAcceptedTiming, setInterviewAcceptedTiming] =
    useState("6 days ago");
  const [offerTiming, setOfferTiming] = useState("4 days ago");
  const [offerAcceptedTiming, setOfferAcceptedTiming] = useState("2 days ago");
  const [Dimensions, setDimensions] = useState(getWindowDimensions());


  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };


  

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  return (
    <>
    <div className="See-History-Aligment"  onClick={(e) => {e.stopPropagation()}} >
      <Modal
       wrapClassName="custom-stages-modal" 
        className={
          status == "Retracted" || status == "Declined"
            ? "stages_modal_retracted"
            : status == "Interview Cancelled"
            ? "stages_modal_interview_declined"
            : status == "Offer Declined"
            ? "stages_modal_offer_declined"
            : "stages_modal"
        }
        title="Stages"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        width="100vw"
      >
        <div className="content">
          <div className="progressLineContainer">
            {status == "Interview Cancelled" ||
            status == "Retracted" ||
            status == "Declined" ||
            status == "Offer Declined" ? null : (
              <div className="line" style={{marginLeft: (Dimensions.width <768) ?  '-1.5rem':"-2.75rem"}}>&nbsp;</div>
            )}
          </div>

          <div className="mainProgressDataContainer">
            <div className="progressDataContainer">
              <div className="progressSubDiv">
                <div className="progress-status">
                  {NewBid.includes(status) ||
                  InReview.includes(status) ||
                  Hired.includes(status) ||
                  Final.includes(status) ? (
                    <CheckCircleFilled
                      style={{
                        color: "green",
                        fontSize: "1.5em",
                        backgroundColor: "#ffff",
                        marginLeft:'0.1rem'
                      }}
                    />
                  ) : (
                    <div className="circle-black" style={{marginLeft:'0.1rem'}}></div>
                  )}
                </div>

                <div className="progress-status-line">
                  {status == "New" ? (
                    <div className="status-line">&nbsp;</div>
                  ) : status == "Retracted" || status == "Declined" ? (
                    <div className="status-line-retracted">&nbsp;</div>
                  ) : (
                    <div className="status-line-accepted">&nbsp;</div>
                  )}

                  {status == "Retracted" || status == "Declined" ? (
                    <div className="circle-black-with-dot">
                      <div className="red-dot"></div>
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="stageData">
                <div className="stage-title">
                  <div className="stage-title-name">New</div>
                  {seeHistory?.createdDate ? (
                    <div className="stage-title-timing">{moment(seeHistory?.createdDate).fromNow()}</div> 
                  ) : null}
                </div>

                <div className="stage-status">
                  <div className="stage-status-name">
                    {status == "New"
                      ? "Accepted / Declined / Retracted"
                      : status == "Declined"
                      ? "Declined"
                      : status == "Retracted"
                      ? "Retracted"
                      : "Accepted"}
                  </div>

                  {seeHistory?.AcceptedDate ? (
                    <div className="stage-status-timing">
                      {moment(seeHistory?.AcceptedDate).fromNow()}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            {/* ---------------------------------------------------------- */}

            <div className="progressDataContainer2">
              <div className="progressSubDiv">
                <div className="progress-status">
                  {InReview.includes(status) ||
                  Hired.includes(status) ||
                  Final.includes(status)  ? (
                    <CheckCircleFilled
                      style={{
                        color: "green",
                        fontSize: "1.5em",
                        backgroundColor: "#ffff",
                        marginLeft:'0.1rem'
                      }}
                    />
                  ) : status == "Retracted" || status == "Declined" ? null : (
                    <div className="circle-black" style={{marginLeft:'0.1rem'}}></div>
                  )}
                </div>
                <div className="progress-status-line">
                  {status == "Profile Submitted" ? (
                    <div className="status-line-profile-submitted">&nbsp;</div>
                  ) : status == "Interview" ? (
                    <div className="status-line-interview">&nbsp;</div>
                  ) : status == "Interview Accepted" ? (
                    <div className="status-line-interview-accepted">&nbsp;</div>
                  ) : status == "Interview Cancelled" ? (
                    <div className="status-line-interview-accepted">&nbsp;</div>
                  ) : status == "Offer" ? (
                    <div className="status-line-offer">&nbsp;</div>
                  ) : status == "Offer Accepted" ? (
                    <div className="status-line-offer-accepted">&nbsp;</div>
                  ) : status == "Offer Declined" ? (
                    <div className="status-line-offer-declined">&nbsp;</div>
                  ) : status == "Hired" ? (
                    <div className="status-line-hired">&nbsp;</div>
                  ) : status == "Billing Extend" ? (
                    <div className="status-line-billing-extended">&nbsp;</div>
                  ) : status == "On Billing" ? (
                    <div className="status-line-on-billing">&nbsp;</div>
                  ) : status == "Off Billing" ? (
                    <div className="status-line-off-billing">&nbsp;</div>
                  ) : status == "Hired" ? (
                    <div className="status-line-hired">&nbsp;</div>
                  ) : status == "Canceled" ? (
                    <div className="status-line-hired">&nbsp;</div>
                  ) : status == "Terminated" ? (
                    <div className="status-line-terminated">&nbsp;</div>
                  ) : NewBid.includes(status) ? null : Hired.includes(status) ||
                    Final.includes(status) ? (
                    <div className="status-line-hired">&nbsp;</div>
                  ) : (
                    <div className="status-line">&nbsp;</div>
                  )}

                  {status == "Interview Cancelled" ||
                  status == "Offer Declined" ? (
                    <div className="circle-black-with-dot" style={{marginLeft:'0.1rem'}}>
                      <div className="red-dot"></div>
                    </div>
                  ) : null}
                </div>
              </div>

              {status != "Retracted" && status != "Declined" ? (
                <div className="stageData">
                  <div className="stage-title">
                    <div className="stage-title-name">In Review</div>
                    <div className="stage-title-timing"></div>
                  </div>

                  <div className="stage-status">
                    <div className="stage-status-name">Profile Submitted</div>

                    {seeHistory?.profileSubmited ? (
                      <div className="stage-status-timing">
                        {moment(seeHistory?.profileSubmited).fromNow()}
                      </div>
                    ) : null}
                  </div>
                  <div className="stage-status">
                    <div className="stage-status-name">Interview</div>
                    {seeHistory?.InterviewedOn || seeHistory?.interview ? (
                      <div className="stage-status-timing">
                        {moment(seeHistory?.InterviewedOn ?? seeHistory?.interview).fromNow()}
                      </div>
                    ) : " "}
                  </div>


                  <div className="stage-status">
                    <div className="stage-status-name">
                       Interview Accepted
                    </div>

                    { seeHistory?.InterviewReactOn || seeHistory?.interview ? (
                          <div className="stage-status-timing">
                            {moment(seeHistory?.InterviewReactOn ?? seeHistory?.interview).fromNow()}
                          </div>
                        ) : " "}

                    
                  </div>

                    {status == "Offer Accepted" || status == "Offer"
                    || status == "Offer Declined" || status == "Hired" 
                    || status == "On Billing" || status == "Off Billing" 
                    || status == "Terminated" || status == "Canceled" 
                    || status == "Billing Extend" ? null : (
                    <div className="stage-status">
                      <div className="stage-status-name">
                          Interview Canceled
                    </div>

                      {seeHistory?.InterviewReactOn
                          ? <div className="stage-status-timing">
                          {moment(seeHistory?.InterviewReactOn).fromNow()}
                          </div>
                          : " "} 
                    </div>)
                    }   

                  {/* <div className="stage-status">
                    <div className="stage-status-name">
                      {status == "Interview Cancelled"
                        ? "Interview Cancelled"
                        : "Interview Accepted"}
                    </div>

                    {status == "Interview Cancelled" && seeHistory?.interviewRejectOn
                        ? <div className="stage-status-timing">
                        {moment(seeHistory?.interviewRejectOn).fromNow()}
                        </div>
                        : seeHistory?.interview ? (
                          <div className="stage-status-timing">
                            {moment(seeHistory?.interview).fromNow()}
                          </div>
                        ) : " "}
 
                          
                  </div> */}

                  {status == "Interview Cancelled" ||
                  status == "Retracted" ||
                  status == "Declined" ? null : (
                    <>
                      <div className="stage-status">
                        <div className="stage-status-name">Offer</div>
                        {seeHistory?.OfferCreatedOn ? (
                          <div className="stage-status-timing">
                            {moment(seeHistory?.OfferCreatedOn).fromNow()}
                          </div>
                        ) : null}
                      </div>
                      {status == "Offer Declined" ? null :
                      <div className="stage-status">
                        <div className="stage-status-name">
                           Offer Accepted
                        </div>
                        {seeHistory?.offerAccepted ? (
                          <div className="stage-status-timing">
                            {moment(seeHistory?.offerAccepted).fromNow()}
                          </div>
                        ) : null}
                      </div>}

                      {status == "Offer Accepted" || status == "Hired" || status == "On Billing" || status == "Off Billing" 
                      || status == "Terminated" || status == "Canceled" || status == "Billing Extend" ? null : 
                      <div className="stage-status">
                        <div className="stage-status-name">
                           Offer Declined 
                        </div>
                        {seeHistory?.offerAccepted ? (
                          <div className="stage-status-timing">
                            {moment(seeHistory?.offerAccepted).fromNow()}
                          </div>
                        ) : null}
                      </div>}
                      
                    </>
                  )}
                </div>
              ) : null}
            </div>

            {/* ---------------------------------------------------------- */}

            <div className="progressDataContainer3">
              <div className="progressSubDiv">
                <div className="progress-status">
                  {Hired.includes(status) || Final.includes(status) ? (
                    <CheckCircleFilled
                      style={{
                        color: "green",
                        fontSize: "1.5em",
                        backgroundColor: "#ffff",
                        marginLeft:'0.1rem'
                      }}
                    />
                  ) : status == "Interview Cancelled" ||
                    status == "Retracted" ||
                    status == "Declined" ||
                    status == "Offer Declined" ? null : (
                    <div className="circle-black" style={{marginLeft:'0.1rem'}}></div>
                  )}
                </div>

                <div className="progress-status-line">
                  {status == "On Billing" ? (
                    <div className="status-line-onbilling">&nbsp;</div>
                  ) : status == "Billing Extend" ||
                    status == "Off Billing" ||
                    status == "Terminated" ||
                    status == "Canceled" ? (
                    <div className="status-line-billing-extend">&nbsp;</div>
                  ) : null}
                </div>
              </div>

              {status == "Interview Cancelled" ||
              status == "Retracted" ||
              status == "Declined" || status == "Offer Declined"? null : (
                <div className="stageData">
                  <div className="stage-title">
                    <div className="stage-title-name"
                    // style={{marginLeft:'7px'}}
                    >Hired</div>
                    {seeHistory?.HiredOn ? (
                    <div className="stage-title-timing">{moment(seeHistory?.HiredOn).fromNow()}</div> 
                  ) : null}
                    {/* {seeHistory?.HiredOn ? (
                     <div className="stage-status-timing">
                       {moment(seeHistory?.HiredOn).fromNow()}
                      </div>
                      ) : null} */}
                  </div>

                  <div className="stage-status">
                    <div className="stage-status-name">On Billing</div>
                    {/* <div className="stage-status-timing">1 day ago</div> */}
                  </div>
                  {seeHistory?.BillingOn ? (
                          <div className="stage-status-timing">
                            {moment(seeHistory?.BillingOn).fromNow()}
                          </div>
                        ) : null}
                {status == "Off Billing" || status == "Terminated" || status == "Canceled" ? null : 
                  <div className="stage-status">
                    <div className="stage-status-name">Billing Extended</div>
                    {seeHistory?.BillingExtendedOn ? (
                          <div className="stage-status-timing">
                            {moment(seeHistory?.BillingExtendedOn).fromNow()}
                          </div>
                        ) : null}</div> }
                  </div>
              )}
            </div>

            {/* ---------------------------------------------------------- */}

            <div className="progressDataContainer4">
              <div className="progressSubDiv">
                <div className="progress-status">
                  {Final.includes(status) ? (
                    <CheckCircleFilled
                      style={{
                        color: "green",
                        fontSize: "1.5em",
                        backgroundColor: "#ffff",
                        marginLeft:'0.1rem'
                      }}
                    />
                  ) : status == "Interview Cancelled" ||
                    status == "Retracted" ||
                    status == "Declined" ||
                    status == "Offer Declined" ? null : (
                    <div className="circle-black" style={{marginLeft:'0.1rem'}}></div>
                  )}
                </div>

                <div className="progress-status-line">
                  <div className="status-line">&nbsp;</div>
                </div>
              </div>

              {status != "Interview Cancelled" &&
              status != "Retracted" &&
              status != "Declined" &&
              status != "Offer Declined" ? (
                <div className="stageData">
                  <div className="stage-title">
                    <div className="stage-title-name">
                      {status == "Terminated"
                        ? "Terminated"
                        : status == "Canceled"
                        ? "Canceled"
                        : status == "Off Billing"
                        ? "Off Billing"
                        : "Off Biling / Canceled / Terminated"}
                    </div>
                    {status == "Terminated" && seeHistory?.TerminatedOn ? (
                    <div className="stage-title-timing">{moment(seeHistory?.TerminatedOn).fromNow()}</div> 
                  ) :
                   status == "Canceled" && seeHistory?.CancelledOn ? (
                    <div className="stage-title-timing">{moment(seeHistory?.CancelledOn).fromNow()}</div> 
                  ) :
                  status == "Off Billing" && seeHistory?.BillingOffOn ? (
                    <div className="stage-title-timing">{moment(seeHistory?.BillingOffOn).fromNow()}</div> 
                  ):
                  
                  null}
                    {/* <div className="stage-title-timing">1 day ago</div> */}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Modal>

      {props.mobile ? (
        <HistoryOutlined
          onClick={showModal}
          style={{ cursor: "pointer", color: "#4054b2", fontSize: "5vw" ,marginTop:"8px" }}
        />
      ) : (
        <p onClick={(e) => {showModal()}} className="seeHistory">
          See history
        </p>
      )}
      </div>
      </>
  );
}
